import Vue from 'vue'

/**
 * 全局事件
 * 请使用 'on' 开头定义事件订阅
 */
class GlobalEvent {

    constructor() {
        this._vue = new Vue()
    }

    menuRerander () { //事件发布
        this._vue.$emit('menuRerander')
    }
    onMenuRerander (callback) { //事件订阅
        this._vue.$off('menuRerander')
        this._vue.$on('menuRerander', callback)
    }

}

let globalEvent = new GlobalEvent()

export default globalEvent